/**
 * Canonical public URL for a company's profile. Keep this path aligned with
 * the public `/p/:tenantCode` route and the links generated by the backend.
 */
export const publicOrganizationPath = (tenantCode: string): string =>
  `/p/${encodeURIComponent(tenantCode.trim())}`;

export const publicOrganizationUrl = (tenantCode: string): string =>
  new URL(publicOrganizationPath(tenantCode), window.location.origin).toString();
